export function customSelect() {
    if ($("select:not(.woof_mselect)").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            flipDropToFit: false,
            fakeDropInBody: false,
            maxVisibleItems: 8
        });

        $(".form-filters select").each(function () {
            let $this = $(this);
            if ($this.find("option:selected").length > 0) {
                $this.parents(".select-wrap").addClass("selected");
            }

            $this.on("change", function () {
                if ($this.find("option:selected").length > 0) {
                    $this.parents(".select-wrap").addClass("selected");
                }

                if ($this.find("option:selected").length === 0) {
                    $this.parents(".select-wrap").removeClass("selected");
                }
            });
        });

        jcf.replaceAll();


    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js